const HELP_CENTER_BASE = 'https://dashboard.ondemandorthodontist.com/resources/help-center';

export const ORTHOPULSE_INSTRUCTIONS_URL = `${HELP_CENTER_BASE}/orthopulse-instructions`;
export const START_DAY_INSTRUCTIONS_URL = `${HELP_CENTER_BASE}/start-day-instructions`;

/** `https://host.com/a/b/c/page` → `https://host.com/.../page`; unparseable or
 *  short paths come back unchanged. */
export function shortenUrl(url: string): string {
    try {
        const parsed = new URL(url);
        const segments = parsed.pathname.split('/').filter(Boolean);
        if (segments.length <= 1) return url;
        const last = segments[segments.length - 1];
        return `${parsed.protocol}//${parsed.host}/.../${last}`;
    } catch {
        return url;
    }
}
